<template>
    <div :class="[$prefixClass.card + '-stroke', 'summary-box']">
        <h6 class="summary-box__title m-b-5">{{title}}</h6>
        <h4 class="summary-box__total primary-color m-0">{{total ? (isFormatSize ? formatSize(total) : total) : '--'}}</h4>
    </div>
</template>
<script>
export default {
    name: 'SummaryBox',
    props: {
        title: {
            type: String,
            required: true
        },
        total: {
            type: [Number, String],
            default: ''
        },
        isFormatSize: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss">
    .summary-box {
        background: $primary-light;
        width: 100%;
        padding: 12px 16px;
    }
</style>